import { useMutation, useQuery } from "@tanstack/react-query";
import axiosConfig from "../axiosInstance";

export const useCreateRole = () =>
  useMutation({
    mutationKey: ["createRole"],
    mutationFn: async (formData) => await axiosConfig.post(`/merchantRole/create`, formData),
  });

export const useUpdateRole = () =>
  useMutation({
    mutationKey: ["updateRole"],
    mutationFn: async (formData) =>
      await axiosConfig.put(`/merchantRole/update/${formData?.id}`, formData),
  });

export const useDeleteRole = () =>
  useMutation({
    mutationKey: ["deleteRole"],
    mutationFn: async (id) => await axiosConfig.delete(`/merchantRole/delete/${id}`),
  });

export const useGetRolePermissions = () =>
  useMutation({
    mutationKey: ["getRolePermissions"],
    mutationFn: async (roleId) =>
      await axiosConfig.get(`/permission/rolePermissions/${roleId}`),
  });

export const useAddPermissionToRole = () =>
  useMutation({
    mutationKey: ["addPermissionToRole"],
    mutationFn: async ({ roleId, permissionNames }) =>
      await axiosConfig.post(`/merchantRole/add-permissions/${roleId}`, {
        permissionNames,
      }),
  });

export const useGetAllRoles = () =>
  useQuery({
    queryKey: ["getAllRoles"],
    queryFn: async () => await axiosConfig.get("/merchantRole/all"),
  });

export const useGetAllPermissions = () =>
  useQuery({
    queryKey: ["getAllPermissions"],
    queryFn: async () => await axiosConfig.get("/merchantPermission/all"),
  });

export const useUpdateRolePermissions = () =>
  useMutation({
    mutationFn: async ({ roleId, permissionNames }) =>
      await axiosConfig.put(`/merchantRole/update-permissions/${roleId}`, {
        permissionNames,
      }),
  });

export const useGetMerchantPermissions = (id) =>
  useQuery({
    queryKey: ["getMerchantPermissions", id],
    queryFn: async () => await axiosConfig.get(`/merchantPermission/merchant/${id}`),
  });

// Permission CRUD
export const useCreatePermission = () =>
  useMutation({
    mutationKey: ["createPermission"],
    mutationFn: async (formData) =>
      await axiosConfig.post(`/merchantPermission/create`, formData),
  });

export const useUpdatePermission = () =>
  useMutation({
    mutationKey: ["updatePermission"],
    mutationFn: async ({ permissionId, ...formData }) =>
      await axiosConfig.put(`/merchantPermission/update/${permissionId}`, formData),
  });

export const useDeletePermission = () =>
  useMutation({
    mutationKey: ["deletePermission"],
    mutationFn: async (permissionId) =>
      await axiosConfig.delete(`/merchantPermission/delete/${permissionId}`),
  });

export const useGetAllAdminPermissions = () =>
  useQuery({
    queryKey: ["getAllAdminPermissions"],
    queryFn: async () => await axiosConfig.get("/merchantPermission/all"),
  });
